export const TOOL_SCHEMA_OPEN_AI = {
  name: "add_here_function_name",
  tool: {
    type: "function",
    function: {
      name: "add_here_function_name",
      description: "Add here a short description of what this function does for OpenAI integration...",
      parameters: {
        type: "object",
        properties: {
          // Example: replace or extend with your own input parameters
          example_input: {
            type: "string",
            description: "Describe the purpose of this input, e.g., user ZIP code or query"
          }
        },
        required: ["example_input"],
        additionalProperties: false
      }
    }
  }
};




export const TOOL_SCHEMA_DEEPGRAM = {
  name: "add_here_function_name",
  tool: {
    type: "function",
    function: {
      name: "add_here_function_name",
      description: "Add here a short description of what this function does for Deepgram integration...",
      strict: true,
      parameters: {
        type: "object",
        properties: {
          // Example: replace or extend with your own input parameters
          example_input: {
            type: "string",
            description: "Describe the purpose of this input, e.g., user ZIP code or command"
          }
        },
        required: ["example_input"],
        additionalProperties: false
      }
    }
  }
};


// export const TOOL_SCHEMA_OPEN_AI = {
//   name: "get_location_by_postalcode",
//   tool: {
//     type: "function",
//     function: {
//       name: "get_location_by_postalcode",
//       description: "Returns the Dental 360 clinic location details..",
//       parameters: {
//         type: "object",
//         properties: {
//           postal_code: {
//             type: "string",
//             description: "U.S. ZIP code, e.g., 60618"
//           }
//         },
//         required: ["postal_code"],
//         additionalProperties: false
//       }
//     }
//   }
// };


// export const TOOL_SCHEMA_DEEPGRAM =
// {
//   name: "get_location_by_postalcode",
//   tool: {
//     type: "function",
//     function: {
//       name: "get_location_by_postalcode",
//       description: "Returns the Dental 360 clinic location details..",
//       strict: true,
//       parameters: {
//         type: "object",
//         properties: {
//           postal_code: {
//             type: "string",
//             description: "U.S. ZIP code, e.g., 60618"
//           }
//         },
//         required: ["postal_code"],
//         additionalProperties: false
//       }
//     }
//   }
// };